import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../../styles/scss/style.css';
import TextParagraph from '../../atoms/TextParagraph';
// import Newsletter from '../../organisms/Newsletter';
import SocialShare from '../../molecules/SocialShare';
import TextHeadingThree from '../../atoms/TextHeadingThree';
import TextAnchor from '../../atoms/TextAnchor';
import { strings } from './FooterContent';

//Returning the component
class Footer extends Component {
	componentWillMount() {
		// Reads the language from the store
		strings.setLanguage(this.props.language);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.language.data !== undefined) {
			strings.setLanguage(nextProps.language.data);
		}
	}
	render() {
		return (
			<footer className="footer">
				<div className="footer__upper">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-6 col-lg-3 ">
								<div className="footer__column">
								<TextHeadingThree text={strings.footer.contactText} />
								<ul className="footer__list">
									<li className="footer__listItem">
										<a className="textAnchor" href="mailto:hello@frankie.tech">hello@frankie.tech</a></li>
									<li className="footer__listItem">
										<a className="textAnchor" href="https://fb.me/frankiecms" target="_blank" rel="noopener noreferrer">facebook.com/frankiecms</a>
									</li>
								</ul>
								</div>

							</div>
							<div className="col-sm-12 col-md-6 col-lg-3">
								<div className="footer__column">
								<TextHeadingThree text={strings.footer.accountText} />
								<ul className="footer__list">
									<li className="footer__listItem">
										<TextAnchor href="/login" text={strings.footer.loginText}/></li>
									<li className="footer__listItem">
										<TextAnchor href="/signup" text={strings.footer.createAccText} /></li>
								</ul>
								</div>
							</div>

								<div className="col-sm-12 col-md-6 col-lg-3">
								<div className="footer__column">
								<TextHeadingThree text={strings.footer.legalText} />
								<ul className="footer__list">
									<li className="footer__listItem">
										<TextAnchor href="/terms-of-use" text={strings.footer.termsText}/></li>
									<li className="footer__listItem">
										<TextAnchor href="/privacy-policy" text={strings.footer.privacyText} /></li>
								</ul>
								</div>
							</div>

							<div className="col-sm-12 col-md-6 col-lg-3">
								<div className="footer__column">
								<ul className="footer__list">
									{/* <li className="footer__listItem">
										<Newsletter
											data={strings.newsletter}
											textButton={strings.footer.newsletterButton}
										/>
									</li> */}
									<li className="footer__listItem">
										<SocialShare
											classType="socialShare--white"
											textParagraph={strings.footer.socials}
										/>
									</li>
								</ul>
								</div>

							</div>

						</div>
					</div>
				</div>
				<div className="footer__copyright">
					<TextParagraph text={strings.footer.paragraphText} />
				</div>
			</footer>
		)
	}
}

//Making sure that it has a text property when it's declared
Footer.propTypes = {
	paragraphText: PropTypes.string
}

export default Footer;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Footer/Footer.jsx